<template>
    <div v-if="includedEquipment.length > 0" class="vehicle-equipment vehicle-section">
        <h3 class="vehicle-section__heading">
            {{ $t('pages.vehicle.equipment_heading') }}
        </h3>

        <div>
            <ul class="checkbox-list">
                <template v-for="(field, index) in filteredEquipment">
                    <CheckboxListItem :key="index" :vehicle="vehicle" :field="field" />
                </template>
            </ul>

            <button
                v-if="isShowAllEquipmentVisible"
                class="vehicle-section__button button button--secondary-contrast button--small"
                @click="$emit('click')"
            >
                {{ $t('pages.vehicle.show_all_equipment') }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CheckboxListItem from '~/components/vehicle/CheckboxListItem.vue';
import equipmentFields from '~/config/equipmentFields';

export default {
    components: {
        CheckboxListItem,
    },
    props: {
        vehicle: {
            type: Object,
            default: () => {},
        },
        displayAll: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters(['isLargeScreen']),
        sliceTo() {
            return this.isLargeScreen ? 8 : 4;
        },
        isShowAllEquipmentVisible() {
            return this.includedEquipment.length > this.sliceTo && !this.displayAll;
        },
        includedEquipment() {
            return equipmentFields.filter(field => {
                if (field === 'toiletType') {
                    return this.vehicle[field] !== 'none';
                }

                if (field === 'towbarSocket') {
                    return typeof this.vehicle.towbarSocket !== 'undefined';
                }

                return this.vehicle[field] === true;
            });
        },
        filteredEquipment() {
            if (!this.isShowAllEquipmentVisible) {
                return this.includedEquipment;
            }

            return this.includedEquipment.slice(0, this.sliceTo);
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.vehicle-equipment {
    .checkbox-list {
        width: 100%;
        @include lg {
            columns: 2;
            column-gap: 20px;
        }

        .checkbox-list-item {
            @include font-size(16px);
            padding-bottom: 8px;
        }
    }
}
</style>
